import moment from 'moment-timezone';

export type TimeRecordDateRow = {
  type: 'time_entry' | 'absence';
  timestamp?: string | null;
  startDate?: string | null;
  createdAt?: string | null;
};

/** Instant shown in the Date/Period column, so the header sorts the time the user sees. */
export function timeRecordDateMillis(record: TimeRecordDateRow, timezone: string): number {
  if (record.type === 'time_entry') {
    const value = record.timestamp || record.createdAt;
    const ms = value ? new Date(value).getTime() : 0;
    return Number.isFinite(ms) ? ms : 0;
  }

  const raw = record.startDate || record.createdAt || '';
  const text = String(raw);
  const datePart = text.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(datePart) && text.length === 10) {
    const ms = moment.tz(datePart, 'YYYY-MM-DD', timezone || 'UTC').valueOf();
    return Number.isFinite(ms) ? ms : 0;
  }
  const ms = raw ? new Date(raw).getTime() : 0;
  return Number.isFinite(ms) ? ms : 0;
}
